<template>
  <div class="flex flex-col gap-4" :class="errorShow ? 'error' : ''">
    <div class="input-range-wrapp">
      <div class="flex items-center mb-2">
        <label :for="returnName">
          <span>
            <span class="opacity-50">{{ label }}</span>
            <span v-if="required" class="text-red text-lg leading-none">*</span>
          </span>
        </label>

        <label :for="returnName + '-range'" class="text-[0px]">
          {{ label }}
        </label>

        <span v-if="tooltip" class="tooltip top">
          <button type="button" class="tooltip-icon" aria-label="info">
            <svg class="w-[6px] h-2">
              <use xlink:href="#icon-question"></use>
            </svg>

            <i class="tooltip-arrow"></i>
          </button>

          <span class="tooltip-popup">
            {{ tooltip }}
          </span>
        </span>
      </div>

      <div class="relative flex h-16 md:h-[72px]">
        <div class="relative w-full h-full">
          <input
            class="block h-full w-full
                 text-base text-blue font-medium
                 px-8 input-border
               focus-visible:border-blue !outline-none duration-200"
            type="text"
            :id="returnName"
            :name="returnName"
            v-model="valueWithMask"
            v-mask="mask"
            placeholder=" "
            autocomplete="off"
          />

          <input
            class="block absolute bottom-0 h-px mx-[3px] outline-none w-full"
            type="range"
            :id="returnName + '-range'"
            :min="0"
            :max="numSteps"
            :value="rangeValue"
            @input="handleRangeInput"
            ref="range"
          />
        </div>

        <div
          v-if="sideTag"
          class="flex items-center justify-center h-full px-6 bg-gray pointer-events-none"
        >
          <div class="text-base text-blue/50 whitespace-nowrap">
            {{ sideTag }}
          </div>
        </div>
      </div>
    </div>

    <p v-if="errorShow" class="text-xs text-red">{{ errorText }}</p>
  </div>
</template>

<script>
import gsap from 'gsap'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

export default {
  name: 'calculatorInputRange',
  data() {
    return {
      valueWithMask: '',
    }
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: '',
    },
    sideTag: {
      type: String,
      default: '',
    },
    errorShow: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: 'This field is required',
    },

    max: {
      type: Number,
      default: 999999999,
    },
    min: {
      type: Number,
      default: 0,
    },
    numSteps: {
      type: Number,
      default: 1000,
    },
    value: {
      type: [Number, String],
      default: 0,
    },

    mask: {
      type: Function,
      default: createNumberMask({
        prefix: '',
        allowDecimal: true,
        includeThousandsSeparator: false,
        allowNegative: false,
      }),
    },
    logScale: {
      type: Boolean,
      default: false,
    },
    parseMaskedValue: {
      type: Function,
      default: value => Number(value),
    },
  },
  computed: {
    returnName: function() {
      const result = this.label
        .split(' ')
        .join('-')
        .toLowerCase()
      return result
    },
    rangeValue() {
      if (this.value === ' ') {
        return 0
      }
      if (!this.logScale) {
        return (this.numSteps * (this.value - this.min)) / (this.max - this.min)
      }
      return (
        (this.numSteps * (Math.log(this.value) - Math.log(this.min))) /
        (Math.log(this.max) - Math.log(this.min))
      )
    },
  },
  methods: {
    handleRangeInput(e) {
      const progress = Number(e.target.value)

      if (!this.logScale) {
        this.trySettingValue(
          this.min + (progress / this.numSteps) * (this.max - this.min)
        )
      } else {
        const value = Math.exp(
          Math.log(this.min) +
            (progress / this.numSteps) *
              (Math.log(this.max) - Math.log(this.min))
        )
        this.trySettingValue(value)
      }
    },
    handleMaskedInput(e) {
      this.valueWithMask = e.target.value
    },
    trySettingValue(value) {
      let finalValue = Math.round(value)
      if (value > this.max) {
        finalValue = this.max
        this.valueWithMask = finalValue
      } else if (value < this.min) {
        finalValue = this.min
        this.valueWithMask = finalValue
      }
      this.$emit('input', finalValue)
    },
  },
  watch: {
    valueWithMask(val) {
      const range = this.$refs.range
      const progress = Number(range.value)

      // set the position for the range slider
      gsap.set(range, {
        backgroundSize: `${(progress / this.numSteps) * 100}% 100%`,
      })

      const number = this.parseMaskedValue(val)
      if (number) {
        this.trySettingValue(number)
      }
    },
    value() {
      this.valueWithMask = this.value
    },
  },
  mounted() {
    this.valueWithMask = this.value
  },
}
</script>
